export const CL = {
  bark:  '#3D2B1F', gold:  '#C9A96E', goldL: '#E8D5B0',
  cream: '#FFFDF8', sand:  '#F5EFE6', olive: '#5A7247',
  sea:   '#2B6F8A', terra: '#C0562B', stone: '#8B7D6B',
};
